import "./styles/index.scss";

import { useEffect, useState } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar/Navbar";

import RightNavbar from "./components/RightNavbar/RightNavbar";
import Dashboard from "./components/Dashboard/Dashboard";
import styles from "./App.module.scss";

import Team from "./components/Team/Team";
import NavContext from "./context/NavContext";
import axios from "axios";
import Private from "./components/authentification/Private";
import Calibration from "./components/calibration/Calibration";

import UserAccountLinker from "./components/InviteUserAfterMail/UserAccountLinker";
import { CabineProvider } from "./context/CabineContext";
import { UserInviteProvider } from "./context/UserInviteContext";
import SuperAdmin from "./components/superAdmin/SuperAdmin";
import Faq from "./components/FAQ/Faq";
import { output, categoriesName } from "./context/ConstantContext";
import Axios from "./_services/caller.service";
import AccountOwner from "./components/AccountOwner/AccountOwner";
import SessionUser from "./_services/session.service";
import Erreur404 from "./pages/Erreur404";
import DownloadOwner from "./components/DownloadOwner/DownloadOwner";
import { AnimatePresence } from "framer-motion";
import PublicRouter from "./router/PublicRouter";

import OwnerWithoutCab from "./components/superAdmin/infos/OwnerWithoutCab";
import Preset from "./components/manageUser/manageUserPreset/Preset";

import ManageMics from "./components/manageMics/ManageMics";
import ManageCabines from "./components/manageSubscriptions/ManageCabines";

//NOTIFY
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import ManageCertificat from "./components/manageCertificat/ManageCertificat";
import Statistics from "./components/statistics/Statistics";

import ManageUser from "./components/manageUser/createUserStepper/ManageUser";
import ManageUserLegacy from "./components/manageUser/ManageUserLegacy";
import WordsLicence from "./components/License/wordsLicence/WordsLicence";
import DiracLicence from "./components/License/diracLicence/DiracLicence";
import HearingLicence from "./components/License/HearingLicense/HearingLicence";
import { ThemeProvider } from "./context/ThemeContext";
import ManagePermissions from "./components/superAdmin/managePermissions/ManagePermissions";
import { PermissionsProvider } from "./context/PermissionsContext";
import { use } from "react";

function App() {
  const location = useLocation();
  const [nav, setNav] = useState(true);

  // AUTH
  const [superAdmin, setSuperAdmin] = useState(false);
  const [supportTeam, setSupportTeam] = useState(false);
  const [user, setUser] = useState(null); //ici si c'est un user simple sans avoir de droits

  const [ownerId, setOwnerId] = useState(null);
  //STORE THE FIRST USER SUPERADMIN CONNECTION
  const [realOwnerId, setRealOwnerId] = useState(null);
  const [realOwnerProfile, setRealOwnerProfile] = useState(null);

  const [userAuth, setUserAuth] = useState(false);
  const [ownerProfile, setOwnerProfile] = useState([]);
  const [adminProfile, setAdminProfile] = useState([]);
  //Loading
  const [errorLogin] = useState("");
  const [loaderLogin, setLoaderLogin] = useState(false);
  const [loading, setLoading] = useState(true);
  const [majCabine, setMajCabine] = useState(false);
  const isLoggedIn = localStorage.getItem("isLoggedIn");
  const [rememberMe, setRememberMe] = useState(false);
  const [privateRoute, setPrivateRoute] = useState(true);
  //Progress Download ZIP
  const [progressWord, setProgressWord] = useState(0);
  const [progressHearing, setProgressHearing] = useState(0);
  const [progressManual, setProgressManual] = useState(0);
  //USER GROUP
  const [userGroup, setUserGroup] = useState(null);

  const [displayOwnerWithoutCabine, setDisplayOwnerWithoutCabine] =
    useState(false); // if true we don't display superadmin components
  const jwt = localStorage.getItem("jwt");
  const navigate = useNavigate();

  axios.defaults.withCredentials = true;
  const loginUser = (email, password) => {
    setLoading(true);

    Axios({
      method: "post",
      url: `${process.env.REACT_APP_API_URL}api/login`,
      withCredentials: true,
      data: {
        email,
        password,
      },
    })
      .then((res) => {
        if (res.status === 209) {
          toast.error(res.data.msg);
          setLoading(false);
          return;
        }

        localStorage.setItem("jwt", res.data.token);
        if (rememberMe) {
          localStorage.setItem("isLoggedIn", true);
        }

        setOwnerId(res.data.id);
        setRealOwnerId(res.data.id);
        setAdminProfile(res.data.profil);
        setRealOwnerProfile(res.data.profil);
        setSuperAdmin(res.data.superAdmin);
        setSupportTeam(res.data.supportTeam);
        setUser(res.data.user);
        setUserAuth(true);
        setLoading(false);

        toast.success("Connexion réussie");

        navigate("/private/dashboard");
      })
      .catch((error) => {
        console.error("❌ Erreur connexion :", error);
        if (error.response && error.response.status === 429) {
          toast.error(
            "Trop de tentatives. Veuillez réessayer dans 15 minutes.",
            { autoClose: false }
          );
        } else {
          toast.error("Erreur de connexion.");
        }
        setLoading(false);
      });
  };

  useEffect(() => {
    // si on est pour une invitation alors on ne fais pas la req pour vérifier userConnect car sinon cela
    // renvoie une 401
    let params = new URLSearchParams(document.location.href);
    const checkIfPageIsUserAccountLinker = params
      .toString()
      .includes("userAccountLinker");
    const checkIfPagesIsVerifyTokenForForgetPassword = params
      .toString()
      .includes("resetPassword");

    if (
      !checkIfPageIsUserAccountLinker &&
      !checkIfPagesIsVerifyTokenForForgetPassword
    ) {
      Axios.get(`/userConnect`)

        .then(function async(response) {
          setOwnerId(response.data.ownerId);
          setRealOwnerId(response.data.id);
          setRealOwnerProfile(response.data.profil);
          setAdminProfile(response.data.profil); // admin profile c'est uniquement quand l'user est admin
          setSuperAdmin(response.data.superAdmin);
          setSupportTeam(response.data.supportTeam);
          setUser(response.data.user);
          setUserAuth(response.data.connected);
          setLoading(false);
        })
        .catch(function () { });
    }
  }, []);

  //PROFILE
  useEffect(() => {
    if (userAuth && ownerId) {
      Axios.get(`/getOwnerProfile/${ownerId}`)

        .then(function async(response) {
          setOwnerProfile(response.data.data);
        })
        .catch(function () { });
    }
  }, [ownerId]);

  //IF IN URL WE HAVE NOT PRIVATE ROUTE WE DON'T SEE NAVBAR
  useEffect(() => {
    let params = new URLSearchParams(document.location.href);
    if (
      params.toString().includes("session") ||
      params.toString().includes("userAccountLinker")
    ) {
      setPrivateRoute(false);
    }
  }, []);

  //IF LOGGED IN IS TRUE SO WE REDIRECT TO DASHBOARD PAGE
  useEffect(() => {
    if (userAuth && location.pathname === "/" && jwt) {
      setPrivateRoute(true);
      navigate("private/dashboard");
    }
  }, [location, jwt, navigate, ownerId, userAuth]);

  const value = {
    nav,
    setNav,
    user,
    setUser,
    userGroup,
    setUserGroup,
    ownerId,
    setOwnerId,
    realOwnerId,
    setRealOwnerId,
    realOwnerProfile,
    setRealOwnerProfile,
    loginUser,
    errorLogin,
    loaderLogin,
    setLoaderLogin,
    userAuth,
    setUserAuth,
    loading,
    setLoading,
    ownerProfile,
    setOwnerProfile,
    adminProfile,
    setAdminProfile,
    superAdmin,
    setSuperAdmin,
    supportTeam,
    setSupportTeam,
    output,
    categoriesName,
    majCabine,
    setMajCabine,
    displayOwnerWithoutCabine,
    setDisplayOwnerWithoutCabine,
    setProgressWord,
    progressWord,
    progressHearing,
    setProgressHearing,
    progressManual,
    setProgressManual,
  };
  const isPrivilegedUser = Boolean(superAdmin) || Boolean(supportTeam);

  return (
    <ThemeProvider>
      <NavContext.Provider value={value}>
        <ToastContainer theme="colored" autoClose={2000} />
        <SessionUser />

        <div className={styles.appLayout}>
          {/* NAVBAR GAUCHE */}
          {userAuth && (
            <aside className={styles.navbar}>
              <Navbar />
            </aside>
          )}

          {/* CONTENU PRINCIPAL */}
          <div className={styles.mainSection}>
            {userAuth && (
              <header className={styles.topbar}>
                <RightNavbar />
              </header>
            )}

            <main className={styles.mainContent}>
              <AnimatePresence mode="wait">
                <Routes location={location} key={location.key}>
                  <Route
                    path="/*"
                    element={
                      <PublicRouter
                        setRememberMe={setRememberMe}
                        isLoggedIn={isLoggedIn}
                      />
                    }
                  />

                  <Route path="/private/" element={<Private />}>
                    <Route path="dashboard" element={<Dashboard />} />
                    <Route
                      path="download"
                      element={!user && <DownloadOwner />}
                    />
                    <Route path="mon-compte" element={<AccountOwner />} />
                    <Route
                      path="calibration"
                      element={
                        <UserInviteProvider>
                          <CabineProvider>
                            <Calibration />
                          </CabineProvider>
                        </UserInviteProvider>
                      }
                    />
                    <Route
                      path="team"
                      element={
                        <UserInviteProvider>
                          <CabineProvider>{!user && <Team />}</CabineProvider>
                        </UserInviteProvider>
                      }
                    />
                    <Route
                      path="abonnements"
                      element={
                        <UserInviteProvider>
                          <CabineProvider>
                            {!user && <ManageCabines />}
                          </CabineProvider>
                        </UserInviteProvider>
                      }
                    />

                    <Route
                      path="superAdmin"
                      element={
                        <UserInviteProvider>
                          {displayOwnerWithoutCabine ? (
                            <OwnerWithoutCab />
                          ) : (
                            <CabineProvider>
                              {isPrivilegedUser && <SuperAdmin />}
                            </CabineProvider>
                          )}
                        </UserInviteProvider>
                      }
                    />
                    <Route path="superAdmin/manageUsers" element={<UserInviteProvider>{displayOwnerWithoutCabine ? <OwnerWithoutCab /> : <CabineProvider>{superAdmin && <ManageUser />}</CabineProvider>}</UserInviteProvider>} />
                    <Route path="superAdmin/manageUsersLegacy" element={<UserInviteProvider>{displayOwnerWithoutCabine ? <OwnerWithoutCab /> : <CabineProvider>{superAdmin && <ManageUserLegacy />}</CabineProvider>}</UserInviteProvider>} />
                    <Route
                      path="superAdmin/manageUserPreset"
                      element={
                        <UserInviteProvider>
                          {displayOwnerWithoutCabine ? (
                            <OwnerWithoutCab />
                          ) : (
                            <CabineProvider>
                              {isPrivilegedUser && <Preset />}
                            </CabineProvider>
                          )}
                        </UserInviteProvider>
                      }
                    />
                    <Route
                      path="superAdmin/manageMics"
                      element={
                        <UserInviteProvider>
                          {displayOwnerWithoutCabine ? (
                            <OwnerWithoutCab />
                          ) : (
                            <CabineProvider>
                              {isPrivilegedUser && <ManageMics />}
                            </CabineProvider>
                          )}
                        </UserInviteProvider>
                      }
                    />
                    <Route
                      path="superAdmin/diracLicence"
                      element={
                        <UserInviteProvider>
                          {displayOwnerWithoutCabine ? (
                            <OwnerWithoutCab />
                          ) : (
                            <CabineProvider>
                              {isPrivilegedUser && <DiracLicence />}
                            </CabineProvider>
                          )}
                        </UserInviteProvider>
                      }
                    />
                    <Route
                      path="superAdmin/wordsLicence"
                      element={
                        <UserInviteProvider>
                          {displayOwnerWithoutCabine ? (
                            <OwnerWithoutCab />
                          ) : (
                            <CabineProvider>
                              {isPrivilegedUser && <WordsLicence />}
                            </CabineProvider>
                          )}
                        </UserInviteProvider>
                      }
                    />
                    <Route
                      path="superAdmin/hearingspaceLicence"
                      element={
                        <UserInviteProvider>
                          {displayOwnerWithoutCabine ? (
                            <OwnerWithoutCab />
                          ) : (
                            <CabineProvider>
                              {isPrivilegedUser && <HearingLicence />}
                            </CabineProvider>
                          )}
                        </UserInviteProvider>
                      }
                    />
                    <Route
                      path="superAdmin/manageCertificat"
                      element={
                        <UserInviteProvider>
                          {displayOwnerWithoutCabine ? (
                            <OwnerWithoutCab />
                          ) : (
                            <CabineProvider>
                              {isPrivilegedUser && <ManageCertificat />}
                            </CabineProvider>
                          )}
                        </UserInviteProvider>
                      }
                    />
                    <Route
                      path="superAdmin/managePermissions"
                      element={
                        <UserInviteProvider>
                          {displayOwnerWithoutCabine ? (
                            <OwnerWithoutCab />
                          ) : (
                            <CabineProvider>
                              {superAdmin && <ManagePermissions />}
                            </CabineProvider>
                          )}
                        </UserInviteProvider>
                      }
                    />
                    <Route
                      path="superAdmin/statistics"
                      element={
                        <UserInviteProvider>
                          {displayOwnerWithoutCabine ? (
                            <OwnerWithoutCab />
                          ) : (
                            <CabineProvider>
                              {isPrivilegedUser && <Statistics />}
                            </CabineProvider>
                          )}
                        </UserInviteProvider>
                      }
                    />
                    <Route path="faq" element={<Faq />} />
                  </Route>

                  <Route path="*" element={<Erreur404 />} />
                </Routes>
              </AnimatePresence>
            </main>
          </div>
        </div>
      </NavContext.Provider>
    </ThemeProvider>
  );
}

export default App;
